<template>
  <div :key="$store.getters['resource/currentResource'].key" class="white-container">
    <PdfView :fields="fields" :editing="true" />
  </div>
</template>

<script>
import fields from './pdfCreationFields.js';
import PdfView from './PdfView';

export default {
  name: 'PdfEditing',
  middleware: 'auth',
  components: {
    PdfView,
  },
  data() {
    return {
      fields: fields,
    };
  },
};
</script>
